// extracted by mini-css-extract-plugin
module.exports = {"top":"StickyTop-module__top___2Hh4v","shadow":"StickyTop-module__shadow___3Qze6"};